import React, { Component } from "react";
import { default as InputRange } from "react-input-range";
import 'react-input-range/lib/css/index.css';


export const slider_selected = { 
  age_filter: {},
  year_filter: {},
}


export default class FilterMinMax extends Component {
    constructor(props) {
      super(props);

      this.title = props.title;
      this.id = props.id;


      // showing but disabled filters
      this.disabled = false;
      if (props.disabled){
          this.disabled = true;
      }


      if (this.id === 'age_filter'){
        this.min = 0;
        this.max = 100;  
      }

      else if (this.id === 'year_filter'){
        this.min = 2012;
        this.max = new Date().getFullYear();
      }
  
      this.state = {
        optionSelected: {
          min: props.selected_min,
          max: props.selected_max,
        },
      };  

      this.onSliderChange = props.onSliderChange;

      this.slider_selected = slider_selected;
      this.slider_selected[this.id] = {
        min: props.selected_min,
        max: props.selected_max,
      };

    }


    changeMinSlider = (min_input) => {

      const min_value = parseInt(min_input.target.value);
      const current_max_value = this.state.optionSelected['max'];

      if (min_value >= this.min && min_value <= current_max_value) {

        const values = {
          min: min_value,
          max: current_max_value,
        };
        
        this.handleChange(values);
      }
    }

    changeMaxSlider = (max_input) => {

      const max_value = parseInt(max_input.target.value);
      const current_min_value = this.state.optionSelected['min'];

      if (max_value >= current_min_value && max_value <= this.max) {

        const values = {
          min: current_min_value,
          max: max_value,
        };
        
        this.handleChange(values);
      }
    }


    handleChange = (selected) => {

      const min_value = selected.min;
      const max_value = selected.max;

      this.setState({
          optionSelected: selected
      });

      this.slider_selected[this.id] = selected;
      this.onSliderChange(this.slider_selected);

      document.getElementById("input-min-"+this.id).value = min_value.toString();
      document.getElementById("input-max-"+this.id).value = max_value.toString();

    };



  
    render() {
      return (

        <div className={this.disabled ? "filter-disabled" : ""}>

          <div className={`${this.state.optionSelected.min !== this.min || this.state.optionSelected.max !== this.max ? "FilterMinMax filter-card filter-active" : "FilterMinMax filter-card"}`}>

              <div className="filter-title">
                  <div className="filter-card-title">{this.title}</div>
              </div>

              <div className="div-input-min-max">

                <div className="div-input-min">
                  <div>min:</div>
                  <input id={"input-min-"+this.id} className="input-min" placeholder={this.state.optionSelected.min} onChange={this.changeMinSlider} type="number" min={this.min} max={this.state.optionSelected.max}></input>
                </div>

                <div className="div-input-max">
                  <div>max:</div>
                  <input id={"input-max-"+this.id} className="input-max" placeholder={this.state.optionSelected.max} onChange={this.changeMaxSlider} type="number" min={this.state.optionSelected.min} max={this.max}></input>
                </div>

              </div>

              <div className="filter-content">
                  <form className="form form-min-max">          

                      <InputRange
                        allowSameValues
                        draggableTrack
                        maxValue={this.max}
                        minValue={this.min}
                        onChange={this.handleChange}
                        value={this.state.optionSelected}
                      />

                  </form>
              </div>

          </div>
        
        </div>
        
      );
    }
  }



  
    
